import React, { useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import config from '../../config';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Button,
  Form,
  FieldCurrencyInput,
  FieldCheckbox,
  FieldCheckboxGroup,
  FieldTextInput,
  FieldLanguagesKnown,
  InlineTextButton,
  FieldDisabledInput,
  FieldPhoneNumberInputWithDialCode,
  Modal,
  PrimaryButton,
  ExternalLink,
} from '../../components';
import css from './EditListingContactForm.module.css';

import arrayMutators from 'final-form-arrays';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import PaymentMethodsForm from '../PaymentMethodsForm/PaymentMethodsForm';
const textfield = 'textfield';
const errorTextField = 'errorTextField';

export const EditListingContactForm = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      // console.log(20, props);

      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        form,
        errors,
        values,
        userNativeLang,
        history,
        onManageDisableScrolling,
        type,
        currentListing,
      } = formRenderProps;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = currentListing?.attributes?.publicData?.isCloneType
        ? false
        : invalid || disabled || submitInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};

      //for same email as profile
      const [defaultEmail, setDefaultEmail] = useState(values.isSameEmailAsProfile);

      const [showTermsModal, setShowTermsModal] = useState(false);

      // console.log(37, values, values.isSameEmailAsProfile, defaultEmail, !defaultEmail);

      const handleSameEmail = value => {
        // console.log(969, value);
        setDefaultEmail(!defaultEmail);

        if (value[0] === 'true') {
          form.change('email', values.profileEmail);
        }

        form.change('isSameEmailAsProfile', value);
      };

      const specialInstructionPlaceholder = intl.formatMessage({
        id: 'EditListingContactForm.specialInstructionPlaceholder',
      });

      // First name
      const firstNameLabel = intl.formatMessage({
        id: 'ContactinformationForm.firstNameLabel',
      });
      const firstNamePlaceholder = intl.formatMessage({
        id: 'ContactinformationForm.firstamePlaceholder',
      });
      const firstNameRequiredMessage = intl.formatMessage({
        id: 'ContactinformationForm.firstNameRequired',
      });
      const firstNameRequired = validators.required(firstNameRequiredMessage);

      // Last name
      const lastNameLabel = intl.formatMessage({
        id: 'ContactinformationForm.lastNameLabel',
      });
      const lastNamePlaceholder = intl.formatMessage({
        id: 'ContactinformationForm.lastNamePlaceholder',
      });
      const lastNameRequiredMessage = intl.formatMessage({
        id: 'ContactinformationForm.lastNameRequired',
      });
      const lastNameRequired = validators.required(lastNameRequiredMessage);
      // email
      const emailLabel = intl.formatMessage({
        id: 'SignupForm.emailLabel',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'ContactInformationForm.emailPlaceholder',
      });
      const emailRequiredMessage = intl.formatMessage({
        id: 'ContactInformationForm.emailRequired',
      });
      const emailRequired = validators.required(emailRequiredMessage);
      const emailInvalidMessage = intl.formatMessage({
        id: 'SignupForm.emailInvalid',
      });
      //   const emailExistMessage = intl.formatMessage({
      //     id: 'SignupForm.emailExist',
      //   });
      const emailValid = validators.emailFormatValid(emailInvalidMessage);
      //   const emailExist = validators.isEmailExist(emailExistMessage, refEmail);
      //   const emailValidator = validators.composeValidators(emailRequired, emailValid, emailExist);
      const emailValidator = validators.composeValidators(emailRequired, emailValid);

      const sameEmailAddress = intl.formatMessage({
        id: 'EditListingContactForm.sameEmailAddress',
      });

      // phone number
      const phoneNumberLabel = intl.formatMessage({
        id: 'ContactInformationForm.phoneNumberLabel',
      });
      const phoneNumberPlaceholder = intl.formatMessage({
        id: 'ContactInformationForm.phoneNumberPlaceholder',
      });
      const phoneNumberRequiredMessage = intl.formatMessage({
        id: 'ContactInformationForm.phoneNumberRequired',
      });
      // const phoneNumberInvalidMessage = intl.formatMessage({
      //   id: 'ContactInformationForm.phoneNumberInvalid',
      // });
      // const phoneNumberValid = validators.phoneNumberRequired(phoneNumberInvalidMessage)
      const phoneNumberRequired = validators.phoneNumberRequired(phoneNumberRequiredMessage);
      const phoneNumberValidator = validators.composeValidators(phoneNumberRequired);
      // const iAgreeText = intl.formatMessage({
      //   id: 'EditListingContactForm.iAgreeText',
      // });
      // const serviceAgreement = intl.formatMessage({
      //   id: 'EditListingContactForm.serviceAgreement',
      // });
      // const termsAndService = intl.formatMessage({
      //   id: 'EditListingContactForm.termsAndService',
      // });
      // const andText = intl.formatMessage({
      //   id: 'EditListingContactForm.andText',
      // });
      // const cancellationPolicy = intl.formatMessage({
      //   id: 'EditListingContactForm.cancellationPolicy',
      // });
      const TandCagreementLabel = (
        <div>
          <FormattedMessage
            id="EditListingContactForm.TandCStatement"
            values={{
              ServiceAgreement: (
                <span className={css.greenText}>
                  <ExternalLink key={'ServiceAgreement'} href="about:blank">
                    <FormattedMessage id="EditListingPricingForm.ServiceAgreement" />
                  </ExternalLink>
                </span>
              ),
              TermsAndService: (
                <span className={css.greenText}>
                  <ExternalLink key={'TermsAndService'} href="about:blank">
                    <FormattedMessage id="EditListingPricingForm.TermsAndService" />
                  </ExternalLink>
                </span>
              ),
              CancellationPolicy: (
                <span className={css.greenText}>
                  <ExternalLink key={' CancellationPolicy'} href="about:blank">
                    <FormattedMessage id="EditListingPricingForm.CancellationPolicy" />
                  </ExternalLink>
                </span>
              ),
            }}
          />
          <FormattedMessage id="EditListingContactForm.PaymentFailText" />
        </div>
      );

      const payPublishText = intl.formatMessage({
        id: 'EditListingContactForm.payPublishText',
      });

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.showListingFailed" />
            </p>
          ) : null}
          <div className={css.subHeadingContainer}>
            <div className={css.RiskHeading}>
              <FormattedMessage id="EditListingContactForm.contactInfoTabLabel" />
            </div>
          </div>
          <div className={css.formcontainer1}>
            <div className={css.field}>
              <FieldTextInput
                // className={css.lastName}
                className={textfield}
                errorClassName={errorTextField}
                type="text"
                id="firstName"
                name="firstName"
                label={firstNameLabel}
                placeholder={firstNamePlaceholder}
                validate={firstNameRequired}
              />
            </div>
            <div className={css.field}>
              <FieldTextInput
                // className={css.lastName}
                className={textfield}
                errorClassName={errorTextField}
                type="text"
                id="lastName"
                name="lastName"
                label={lastNameLabel}
                placeholder={lastNamePlaceholder}
                validate={lastNameRequired}
              />
            </div>
          </div>
          <div className={css.formcontainer1}>
            <div className={css.field}>
              <FieldTextInput
                className={classNames(css.locationAddress, textfield, {
                  [css.disabledField]: !!defaultEmail,
                })}
                errorClassName={errorTextField}
                type="email"
                id={'email'}
                name="email"
                autoComplete="email"
                label={emailLabel}
                placeholder={emailPlaceholder}
                validate={emailValidator}
                //   key={refEmail}
                onChange={e => {
                  // console.log(777, e);
                  const value = e;
                  form.change('isSameEmailAsProfile', null);

                  form.change('email', value);
                }}
                userNativeLang={userNativeLang}
                disabled={!!defaultEmail}
              />
            </div>
            <div className={css.field}>
              <FieldPhoneNumberInputWithDialCode
                name="phoneNumber"
                id={'phoneNumberId'}
                label={phoneNumberLabel}
                placeholder={phoneNumberPlaceholder}
                validate={phoneNumberValidator}
                className={textfield}
                errorClassName={errorTextField}
              />
            </div>
          </div>
          <div className={css.fieldDiv}>
            <FieldCheckbox
              // id={formId ? `${formId}.workingStatus` : 'workingStatus'}
              id="isSameEmailAsProfile"
              name="isSameEmailAsProfile"
              label={sameEmailAddress}
              value={'true'}
              onChange={handleSameEmail}
            />
          </div>
          <div className={css.fieldDiv}>
            <FieldTextInput
              className={textfield}
              id="specialInstructions"
              name="specialInstructions"
              // className={css.description}
              type="textarea"
              label={<FormattedMessage id="EditListingContactForm.specialInstructions" />}
              placeholder={specialInstructionPlaceholder}
            // validate={composeValidators(required(descriptionRequiredMessage))}
            />
          </div>
          {/* {console.log(type, currentListing?.attributes?.state, 159)} */}
          <div className={css.ButtonContainer}>
            {type === 'edit' ? (
              // {type === 'edit' || currentListing?.attributes?.state === 'published' ? (
              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {saveActionMsg}
              </Button>
            ) : (
              <Button
                className={css.submitButton}
                type="button"
                // inProgress={submitInProgress}
                disabled={submitDisabled}
                // ready={submitReady}
                onClick={() => setShowTermsModal(true)}
              >
                {saveActionMsg}
              </Button>
            )}

            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
          <Modal
            className={css.TermsModal}
            id="EditListingContactForm.agreeTermsConditions"
            isOpen={!!showTermsModal}
            onClose={() => {
              setShowTermsModal(false);
            }}
            onManageDisableScrolling={onManageDisableScrolling}
            usePortal
            showCloseButton={false}
          >
            <>
              <div className={css.RiskHeading}>
                <FormattedMessage id="EditListingContactForm.tandCAgreement" />
              </div>
              <div className={css.agreementDiv}>
                <FieldCheckbox
                  id="TandCagreement"
                  name="TandCagreement"
                  label={TandCagreementLabel}
                  value={'true'}
                />
              </div>

              <div className={css.ButtonContainer}>
                <Button
                  className={css.submitButton}
                  type="button"
                  inProgress={submitInProgress}
                  disabled={
                    !(values?.TandCagreement?.length > 0 && values.TandCagreement[0] === 'true')
                  }
                  ready={submitReady}
                  onClick={() => props.onSubmit(values)}
                >
                  {payPublishText}
                </Button>
                <InlineTextButton
                  type="button"
                  className={css.cancelBtn}
                  onClick={() => {
                    setShowTermsModal(false);
                  }}
                >
                  <FormattedMessage id="SignupForm.Cancel" />
                </InlineTextButton>
              </div>
            </>
          </Modal>
        </Form>
      );
    }}
  />
);

EditListingContactForm.defaultProps = { fetchErrors: null };

EditListingContactForm.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingContactForm);
